import { CascoCategoryEnum } from '@insurance/api/requests'
import { Select, SelectProps } from 'antd'
import { useTranslation } from 'react-i18next'

import { formProps } from './utils'

export const VehicleCategorySelect = (props: SelectProps) => {
  const { t } = useTranslation()
  const { vehicleCategoryProps } = formProps(t)

  const options = Object.values(CascoCategoryEnum).map((value) => ({
    label: t(value),
    value
  }))

  return (
    <Select
      placeholder={vehicleCategoryProps.label}
      options={options}
      {...props}
    />
  )
}
